import { init, RematchDispatch, RematchRootState } from '@rematch/core'
import { models, RootModel } from '../models'
import { initialCartState } from '../models/cart'
import { initialOrderState } from '../models/order'

export const store = init({
  models,
  redux: {
    rootReducers: {
      RESET_CART: (state, action) => {
        if (action.type === 'RESET_CART') {
          localStorage.setItem('cartId', '')
          localStorage.setItem('payexref', '')
          const { store, menus } = state
          state = { store, menus, cart: initialCartState, order: initialOrderState }
        }
        return state
      },
    },
  }
})

export type Store = typeof store
export type Dispatch = RematchDispatch<RootModel>
export type RootState = RematchRootState<RootModel>
